import DOMPurify from 'dompurify'

/** Sanitize untrusted HTML — strips scripts, event handlers, iframes.
 *  `target` entra por ADD_ATTR: o painel (Quill) emite `target="_blank"` nos
 *  links da descrição e o default do DOMPurify o remove — sem ele, o link
 *  renderizado navega na mesma aba e tira o participante do app. */
export function sanitizeHtml(dirty: string | undefined | null): string {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, { ADD_ATTR: ['target'] })
}

/** Sanitize embed HTML — allows iframes (quiz/journey slide embeds from admin). */
export function sanitizeEmbedHtml(dirty: string | undefined | null): string {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'loading', 'src'],
  })
}
